<template>
  <loading-content
    :loading="loading"
    :error="error"
    :isTab="false">

    <v-form ref="form">

      <v-text-field
        outline
        v-model="form.name"
        :disabled="readonly"
        :rules="readonly ? [] : [rules.required]"
        :background-color="readonly ? '#ccc' : ''"
        label="NOME DO IRMÃO OU IRMÃ/NAME OF SIBLING"
      />

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            v-model="birthday"
            :rules="readonly ? [] : [rules.date]"
            :disabled="readonly"
            :background-color="readonly ? '#ccc' : ''"
            mask="##/##/####"
            return-masked-value
            placeholder="dd/mm/yyyy"
            label="DATA DE NASCIMENTO/DATE OF BIRTH"
          />
        </v-flex>

        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            v-model="form.school"
            label="ESCOLA/SCHOOL"
            :disabled="readonly"
            :background-color="readonly ? '#ccc' : ''"
          />
        </v-flex>
      </v-layout>

    </v-form>
  </loading-content>
</template>

<script>
import { formatDateToPtBR, formatDateToDbFormat } from '@/helpers/formatDbDate'
import { date as datePattern } from '@/helpers/regex'
import * as api from '@/api'
import LoadingContent from '@/components/LoadingContent'
import { nestedRegistry, formTabs } from '@/mixins'

/**
 * @group Form
 * Componente de form para dados de Irmão/Irmã relacionados ao estudante
 */
export default {
  name: 'FormSibling',

  mixins: [nestedRegistry, formTabs],

  components: {
    LoadingContent
  },

  props: {
    // Atributos do irmao/irma
    sibling_attributes: {
      type: Object,
      default: () => ({})
    },

    // Index da lista original
    sibling_id: {
      type: Number,
      default: null
    },

    // Controle de modo de leitura da form
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    rules: {
      required: value => !!value || 'Campo obrigatório/Field is required',
      date: value => {
        return !value || datePattern.test(value) || 'Data inválida/Invalid date'
      }
    }
  }),

  mounted () {
    if (!this.readonly) {
      let promise

      if (this.sibling_id) {
        promise = api.siblings.edit(this.currentStudentId, this.sibling_id)
      } else {
        promise = api.siblings.getModel(this.currentStudentId)
      }

      promise
        .then(this.handleResponse)
        .catch(this.handleError)
        .finally(this.handleFinally)
    } else {
      this.readonlyLoad(this.sibling_attributes)
    }
  },

  computed: {
    birthday: {
      get () {
        return formatDateToPtBR(this.form.birthday)
      },

      set (newValue) {
        this.form.birthday = formatDateToDbFormat(newValue)
      }
    }
  },

  methods: {
    // @vuese Método para envio de dados da form
    save () {
      if (this.validateForm()) {
        this.$emit('sibling_attributes', this.form)
      }
    }
  },

  watch: {
    sibling_attributes (newValue) {
      this.form = newValue
    }
  }
}
</script>
